import { Grid } from '@mui/material';
import { ReactNode } from 'react';

const sidebarGrid = {
  xs: 3,
  md: 3,
  lg: 2,
  xl: 2,
};

const contentGrid = {
  xs: 9,
  md: 9,
  lg: 10,
  xl: 10,
};

export function SidebarView({ sidebar, children }: { sidebar: ReactNode; children: ReactNode }) {
  return (
    <Grid container sx={{ height: '100%' }}>
      <Grid
        item
        {...sidebarGrid}
        height="100%"
        sx={{
          'backgroundColor': 'grey.100', // or use theme.palette.grey[100]
          'display': 'flex',
          'flexDirection': 'column',
          'paddingTop': 4, // 32px / 8 = 4
          'height': '100%',
          'marginLeft': -2.5, // -20px / 8 = -2.5

          '& .MuiListItem-root': {
            textAlign: 'right',
            justifyContent: 'right',
            paddingRight: 2.5, // 20px / 8 = 2.5
            fontSize: '1.2em',
            fontWeight: 'lighter',
          },

          '& .MuiListItemText-primary': {
            textAlign: 'right',
          },

          '& .Mui-selected': {
            backgroundColor: 'grey.100', // same as $bg-grey
            borderRight: '4px solid',
            borderRightColor: 'primary.main', // assuming $main-blue is your primary color
          },
        }}
      >
        {sidebar}
      </Grid>
      <Grid item {...contentGrid}>
        {children}
      </Grid>
    </Grid>
  );
}
